import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    sx?: SxType
}

const MarkerSvgIcon = ({sx={}}: IProps) => {
    return (
        <SvgIcon
            sx={{
                fill:'#2EBEFD',
                ...sx,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="14"
                fill="none"
                viewBox="0 0 12 14"
            >
                <path
                    d="M6 7c.367 0 .68-.13.941-.392.262-.261.392-.575.392-.942 0-.366-.13-.68-.392-.941A1.284 1.284 0 006 4.333c-.367 0-.68.13-.942.392a1.284 1.284 0 00-.391.941c0 .367.13.68.391.942C5.32 6.869 5.633 7 6 7zm0 4.9c1.355-1.245 2.361-2.375 3.017-3.392C9.671 7.491 10 6.588 10 5.8c0-1.211-.386-2.203-1.159-2.975C8.07 2.052 7.122 1.666 6 1.666s-2.07.386-2.842 1.159C2.386 3.597 2 4.589 2 5.8c0 .789.328 1.691.983 2.708C3.64 9.525 4.644 10.655 6 11.9zm0 1.766C4.21 12.144 2.875 10.73 1.992 9.425 1.108 8.119.667 6.91.667 5.8c0-1.667.536-2.995 1.608-3.984C3.347.827 4.589.333 6 .333c1.41 0 2.653.494 3.725 1.483 1.072.99 1.608 2.317 1.608 3.984 0 1.11-.441 2.32-1.325 3.625-.883 1.305-2.22 2.72-4.008 4.241z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default MarkerSvgIcon;